import { render, staticRenderFns } from "./tabindex.vue?vue&type=template&id=f311b698"
import script from "./tabindex.vue?vue&type=script&lang=js"
export * from "./tabindex.vue?vue&type=script&lang=js"
import style0 from "./tabindex.vue?vue&type=style&index=0&id=f311b698&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports